import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, MapPin } from 'lucide-react';
interface Sale {
  name: string;
  country: string;
  timeAgo: string;
}
const salesData: Sale[] = [{
  name: 'María G.',
  country: 'Argentina 🇦🇷',
  timeAgo: 'hace 2 min'
}, {
  name: 'Camila R.',
  country: 'Colombia 🇨🇴',
  timeAgo: 'hace 5 min'
}, {
  name: 'Valentina P.',
  country: 'México 🇲🇽',
  timeAgo: 'hace 8 min'
}, {
  name: 'Sofía L.',
  country: 'Chile 🇨🇱',
  timeAgo: 'hace 12 min'
}, {
  name: 'Luciana M.',
  country: 'Perú 🇵🇪',
  timeAgo: 'hace 15 min'
}, {
  name: 'Andrea C.',
  country: 'Ecuador 🇪🇨',
  timeAgo: 'hace 18 min'
}, {
  name: 'Daniela F.',
  country: 'Rep. Dominicana 🇩🇴',
  timeAgo: 'hace 22 min'
}, {
  name: 'Gabriela S.',
  country: 'Venezuela 🇻🇪',
  timeAgo: 'hace 25 min'
}, {
  name: 'Carolina T.',
  country: 'Uruguay 🇺🇾',
  timeAgo: 'hace 30 min'
}, {
  name: 'Florencia B.',
  country: 'Paraguay 🇵🇾',
  timeAgo: 'hace 35 min'
}, {
  name: 'Natalia V.',
  country: 'Bolivia 🇧🇴',
  timeAgo: 'hace 40 min'
}, {
  name: 'Isabella D.',
  country: 'Costa Rica 🇨🇷',
  timeAgo: 'hace 45 min'
}, {
  name: 'Paola H.',
  country: 'Guatemala 🇬🇹',
  timeAgo: 'hace 50 min'
}, {
  name: 'Laura J.',
  country: 'Panamá 🇵🇦',
  timeAgo: 'hace 55 min'
}, {
  name: 'Alejandra N.',
  country: 'Honduras 🇭🇳',
  timeAgo: 'hace 1 hora'
}, {
  name: 'Fernanda Q.',
  country: 'El Salvador 🇸🇻',
  timeAgo: 'hace 1 hora'
}, {
  name: 'Mariana K.',
  country: 'Nicaragua 🇳🇮',
  timeAgo: 'hace 2 horas'
}, {
  name: 'Catalina W.',
  country: 'Puerto Rico 🇵🇷',
  timeAgo: 'hace 2 horas'
}];
function shuffleArray<T>(array: T[]): T[] {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}
export function SalesNotifications() {
  const [currentSale, setCurrentSale] = useState<Sale | null>(null);
  const [visible, setVisible] = useState(false);
  const [queue, setQueue] = useState<Sale[]>(() => shuffleArray(salesData));
  const [index, setIndex] = useState(0);
  const showNotification = useCallback(() => {
    let currentQueue = queue;
    let currentIndex = index;
    if (currentIndex >= currentQueue.length) {
      currentQueue = shuffleArray(salesData);
      currentIndex = 0;
      setQueue(currentQueue);
    }
    setCurrentSale(currentQueue[currentIndex]);
    setIndex(currentIndex + 1);
    setVisible(true);
    // Hide after 4 seconds
    setTimeout(() => {
      setVisible(false);
    }, 4000);
  }, [queue, index]);
  useEffect(() => {
    // First notification after 8 seconds
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 8000);
    return () => clearTimeout(initialTimeout);
  }, []);
  useEffect(() => {
    if (!visible && currentSale) {
      // Show next notification 12-20 seconds after the previous one hides
      const delay = 12000 + Math.random() * 8000;
      const timeout = setTimeout(() => {
        showNotification();
      }, delay);
      return () => clearTimeout(timeout);
    }
  }, [visible, currentSale, showNotification]);
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs" data-id="element-223">
      <AnimatePresence data-id="element-224">
        {visible && currentSale && <motion.div initial={{
        opacity: 0,
        y: 30,
        x: -20
      }} animate={{
        opacity: 1,
        y: 0,
        x: 0
      }} exit={{
        opacity: 0,
        y: 20,
        x: -10
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-white rounded-xl shadow-2xl shadow-black/10 border border-[#F5E6E0] p-4 flex items-center gap-3" data-id="element-225">
            <div className="w-10 h-10 bg-gradient-to-br from-[#9B2C5E] to-[#E05275] rounded-full flex items-center justify-center shrink-0" data-id="element-226">
              <ShoppingBag className="w-5 h-5 text-white" data-id="element-227" />
            </div>
            <div className="min-w-0" data-id="element-228">
              <p className="text-sm font-bold text-[#1A1A2E] truncate" data-id="element-229">
                {currentSale.name} se inscribió
              </p>
              <p className="text-xs text-gray-500 flex items-center gap-1" data-id="element-230">
                <MapPin className="w-3 h-3 shrink-0" data-id="element-231" />
                <span className="truncate" data-id="element-232">{currentSale.country}</span>
                <span className="text-[#C9A96E] ml-1 shrink-0" data-id="element-233">
                  · {currentSale.timeAgo}
                </span>
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}